module.exports = __webpack_public_path__ + "static/media/kid_avatar_01.8b2d054b.png";